<script setup lang="ts">
import { onMounted } from 'vue'
import type { Variant } from '@/shared/types/common.types'

interface Props {
  variant: Variant
}

defineProps<Props>()

const model = defineModel<number>({ required: true })

onMounted(() => {
  model.value = 0
})
</script>

<template>
  <div class="absolute left-0 right-0 bottom-0 overflow-hidden">
    <div class="w-full bg-white/10">
      <div
        class="h-2 origin-left transition-width linear duration-[3s]"
        :class="{
          'bg-success/60': variant === 'success',
          'bg-error/60': variant === 'error',
          'bg-warning/60': variant === 'warning',
          'bg-info/60': variant === 'info',
        }"
        :style="{ width: model + '%' }"
      ></div>
    </div>
  </div>
</template>
